import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import PostTypeSelector from "./PostTypeSelector";
import TextPostForm from "./TextPostForm";
import PhotoPostForm from "./PhotoPostForm";
import ResearchPostForm from "./ResearchPostForm";
import QuestionPostForm from "./QuestionPostForm";
import CollaborationPostForm from "./CollaborationPostForm";
import PollPostForm from "./PollPostForm";
import MilestonePostForm from "./MilestonePostForm";
import "./CreatePostModal.css";

const CreatePostModal = ({
  initialPostType = "text",
  onClose,
  onSuccess,
  onPostCreated,
}) => {
  const [postType, setPostType] = useState(initialPostType);

  // Handle both onSuccess and onPostCreated for backward compatibility
  const handleSuccess = (newPost) => {
    if (onSuccess) onSuccess(newPost);
    if (onPostCreated) onPostCreated(newPost);
  };

  const renderForm = () => {
    switch (postType) {
      case "text":
        return <TextPostForm onSuccess={handleSuccess} onCancel={onClose} />;
      case "photo":
        return <PhotoPostForm onSuccess={handleSuccess} onCancel={onClose} />;
      case "research":
        return (
          <ResearchPostForm onSuccess={handleSuccess} onCancel={onClose} />
        );
      case "question":
        return (
          <QuestionPostForm onSuccess={handleSuccess} onCancel={onClose} />
        );
      case "collaboration":
        return (
          <CollaborationPostForm onSuccess={handleSuccess} onCancel={onClose} />
        );
      case "poll":
        return <PollPostForm onSuccess={handleSuccess} onCancel={onClose} />;
      case "milestone":
        return (
          <MilestonePostForm onSuccess={handleSuccess} onCancel={onClose} />
        );
      default:
        return <TextPostForm onSuccess={handleSuccess} onCancel={onClose} />;
    }
  };

  return (
    <div className="cpm-overlay" onClick={onClose}>
      <div className="cpm-content" onClick={(e) => e.stopPropagation()}>
        <div className="cpm-header">
          <h3 className="cpm-title">Create Post</h3>
          <button
            className="cpm-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            <FaTimes />
          </button>
        </div>

        <PostTypeSelector selectedType={postType} onSelectType={setPostType} />

        <div className="cpm-body">{renderForm()}</div>
      </div>
    </div>
  );
};

export default CreatePostModal;
